import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
const sizeStyles = {
    xs: 'size-[3px]',
    sm: 'size-1',
    md: 'size-1.5',
    lg: 'size-2',
};
export default function DotSeparator({ size = 'sm', color = 'bg-heading', className }) {
    return _jsx("div", { className: classNames('shrink-0 rounded-full', sizeStyles[size], color, className) });
}
